// NOTE: AUTO GENERATED FILE! Do not modify directly!

import { categoryRequired as categoryRequiredFn } from '../modules/PostEditor/validators/category-required';
import { checkDateAndTime as checkDateAndTimeFn } from '../modules/PostEditor/validators/check-date-and-time';
import { checkDisconectedProfiles as checkDisconectedProfilesFn } from '../modules/PostEditor/validators/check-disconected-profiles';
import { checkExpiryCount as checkExpiryCountFn } from '../modules/PostEditor/validators/check-expiry-count';
import { checkExpiryDate as checkExpiryDateFn } from '../modules/PostEditor/validators/check-expiry-date';
import { checkLinkPreviewSuppressed as checkLinkPreviewSuppressedFn } from '../modules/PostEditor/validators/check-link-preview-suppressed';
import { checkLinksPresent as checkLinksPresentFn } from '../modules/PostEditor/validators/check-links-present';
import { checkQueuePosition as checkQueuePositionFn } from '../modules/PostEditor/validators/check-queue-position';
import { checkRecurringInterval as checkRecurringIntervalFn } from '../modules/PostEditor/validators/check-recurring-interval';
import { expireDateRequired as expireDateRequiredFn } from '../modules/PostEditor/validators/expire-date-count-required';
import { expireCountRequired as expireCountRequiredFn } from '../modules/PostEditor/validators/expire-date-count-required';
import { facebookContentRequired as facebookContentRequiredFn } from '../modules/PostEditor/validators/facebook-content-required';
import { facebookMediaLimit as facebookMediaLimitFn } from '../modules/PostEditor/validators/facebook-media-limit';
import { facebookTextCharLimit as facebookTextCharLimitFn } from '../modules/PostEditor/validators/facebook-text-char-limit';
import { facebookTwitterLineBreakLimit as facebookTwitterLineBreakLimitFn } from '../modules/PostEditor/validators/facebook-twitter-line-break-limit';
import { finishUpload as finishUploadFn } from '../modules/PostEditor/validators/finish-upload';
import { googleMediaLimit as googleMediaLimitFn } from '../modules/PostEditor/validators/google-media-limit';
import { googleMinMedia as googleMinMediaFn } from '../modules/PostEditor/validators/google-min-media';
import { googleTextCharLimit as googleTextCharLimitFn } from '../modules/PostEditor/validators/google-text-char-limit';
import { instagramFacebookFirstCommentCharLimit as instagramFacebookFirstCommentCharLimitFn } from '../modules/PostEditor/validators/instagram-facebook-first-comment-char-limit';
import { instagramHashtagLimit as instagramHashtagLimitFn } from '../modules/PostEditor/validators/instagram-hashtag-limit';
import { instagramMediaLimit as instagramMediaLimitFn } from '../modules/PostEditor/validators/instagram-media-limit';
import { instagramTextCharLimit as instagramTextCharLimitFn } from '../modules/PostEditor/validators/instagram-text-char-limit';
import { linkedinFirstCommentCharLimit as linkedinFirstCommentCharLimitFn } from '../modules/PostEditor/validators/linkedin-first-comment-char-limit';
import { linkedinMediaLimit as linkedinMediaLimitFn } from '../modules/PostEditor/validators/linkedin-media-limit';
import { linkedinTextCharLimit as linkedinTextCharLimitFn } from '../modules/PostEditor/validators/linkedin-text-char-limit';
import { mediaRequired as mediaRequiredFn } from '../modules/PostEditor/validators/media-required';
import { noGifsAllowed as noGifsAllowedFn } from '../modules/PostEditor/validators/no-gifs-allowed';
import { noImagesAllowed as noImagesAllowedFn } from '../modules/PostEditor/validators/no-images-allowed';
import { noMixedMedia as noMixedMediaFn } from '../modules/PostEditor/validators/no-mixed-media';
import { noVideosAllowed as noVideosAllowedFn } from '../modules/PostEditor/validators/no-videos-allowed';
import { pinterestBoardRequired as pinterestBoardRequiredFn } from '../modules/PostEditor/validators/pinterest-board-required';
import { pinterestLineBreakLimit as pinterestLineBreakLimitFn } from '../modules/PostEditor/validators/pinterest-line-break-limit';
import { pinterestMediaLimit as pinterestMediaLimitFn } from '../modules/PostEditor/validators/pinterest-media-limit';
import { pinterestTextCharLimit as pinterestTextCharLimitFn } from '../modules/PostEditor/validators/pinterest-text-char-limit';
import { pinterestDuplicatesCheck as pinterestDuplicatesCheckFn } from '../modules/PostEditor/validators/pinterest-twitter-duplicates-check';
import { preventTwDuplicate as preventTwDuplicateFn } from '../modules/PostEditor/validators/pinterest-twitter-duplicates-check';
import { preventAudioOnlyFiles as preventAudioOnlyFilesFn } from '../modules/PostEditor/validators/prevent-audio-only-files';
import { preventPostNowForDisconnected as preventPostNowForDisconnectedFn } from '../modules/PostEditor/validators/prevent-post-now-for-disconnected';
import { profileRequired as profileRequiredFn } from '../modules/PostEditor/validators/profile-required';
import { scheduleTextOrMediaVariations as scheduleTextOrMediaVariationsFn } from '../modules/PostEditor/validators/schedule-text-or-media-variations';
import { tikTokAudienceRequired as tikTokAudienceRequiredFn } from '../modules/PostEditor/validators/tik-tok-audience-required';
import { tikTokMediaLimit as tikTokMediaLimitFn } from '../modules/PostEditor/validators/tik-tok-media-limit';
import { tikTokTextCharLimit as tikTokTextCharLimitFn } from '../modules/PostEditor/validators/tik-tok-text-char-limit';
import { tikTokVideoLength as tikTokVideoLengthFn } from '../modules/PostEditor/validators/tik-tok-video-length';
import { tikTokVideoSize as tikTokVideoSizeFn } from '../modules/PostEditor/validators/tik-tok-video-size';
import { titleCharLimit as titleCharLimitFn } from '../modules/PostEditor/validators/title-char-limit';
import { twitterMediaLimit as twitterMediaLimitFn } from '../modules/PostEditor/validators/twitter-media-limit';
import { twitterTextCharLimit as twitterTextCharLimitFn } from '../modules/PostEditor/validators/twitter-text-char-limit';
import { videoNotTranscoded as videoNotTranscodedFn } from '../modules/PostEditor/validators/video-not-transcoded';

export type PostEditorErrorKeys =
  | 'categoryRequired'
  | 'checkDateAndTime'
  | 'checkDisconectedProfiles'
  | 'checkExpiryCount'
  | 'checkExpiryDate'
  | 'checkLinkPreviewSuppressed'
  | 'checkLinksPresent'
  | 'checkQueuePosition'
  | 'checkRecurringInterval'
  | 'expireCountRequired'
  | 'expireDateRequired'
  | 'facebookContentRequired'
  | 'facebookMediaLimit'
  | 'facebookTextCharLimit'
  | 'facebookTwitterLineBreakLimit'
  | 'finishUpload'
  | 'googleMediaLimit'
  | 'googleMinMedia'
  | 'googleTextCharLimit'
  | 'instagramFacebookFirstCommentCharLimit'
  | 'instagramHashtagLimit'
  | 'instagramMediaLimit'
  | 'instagramTextCharLimit'
  | 'linkedinFirstCommentCharLimit'
  | 'linkedinMediaLimit'
  | 'linkedinTextCharLimit'
  | 'mediaRequired'
  | 'noGifsAllowed'
  | 'noImagesAllowed'
  | 'noMixedMedia'
  | 'noVideosAllowed'
  | 'pinterestBoardRequired'
  | 'pinterestDuplicatesCheck'
  | 'pinterestLineBreakLimit'
  | 'pinterestMediaLimit'
  | 'pinterestTextCharLimit'
  | 'preventAudioOnlyFiles'
  | 'preventPostNowForDisconnected'
  | 'preventTwDuplicate'
  | 'profileRequired'
  | 'scheduleTextOrMediaVariations'
  | 'tikTokAudienceRequired'
  | 'tikTokMediaLimit'
  | 'tikTokTextCharLimit'
  | 'tikTokVideoLength'
  | 'tikTokVideoSize'
  | 'titleCharLimit'
  | 'twitterMediaLimit'
  | 'twitterTextCharLimit'
  | 'videoNotTranscoded';
// we need to export those keys as a const since we need to use it in helper function where we check for the
// PostEditorErrorKeys type, In TypeScript when we want to type guard a string to be a specific literal type we would
// normally use a type assertion. However, we cannot do that directly with a type alias like PostEditorErrorKeys.
// An alternative approach here is to manually list the keys that PostEditorErrorKeys can be. It's not the most elegant
// solution, but it will work:
export const postEditorErrorKeys: PostEditorErrorKeys[] = [
  'categoryRequired',
  'checkDateAndTime',
  'checkDisconectedProfiles',
  'checkExpiryCount',
  'checkExpiryDate',
  'checkLinkPreviewSuppressed',
  'checkLinksPresent',
  'checkQueuePosition',
  'checkRecurringInterval',
  'expireCountRequired',
  'expireDateRequired',
  'facebookContentRequired',
  'facebookMediaLimit',
  'facebookTextCharLimit',
  'facebookTwitterLineBreakLimit',
  'finishUpload',
  'googleMediaLimit',
  'googleMinMedia',
  'googleTextCharLimit',
  'instagramFacebookFirstCommentCharLimit',
  'instagramHashtagLimit',
  'instagramMediaLimit',
  'instagramTextCharLimit',
  'linkedinFirstCommentCharLimit',
  'linkedinMediaLimit',
  'linkedinTextCharLimit',
  'mediaRequired',
  'noGifsAllowed',
  'noImagesAllowed',
  'noMixedMedia',
  'noVideosAllowed',
  'pinterestBoardRequired',
  'pinterestDuplicatesCheck',
  'pinterestLineBreakLimit',
  'pinterestMediaLimit',
  'pinterestTextCharLimit',
  'preventAudioOnlyFiles',
  'preventPostNowForDisconnected',
  'preventTwDuplicate',
  'profileRequired',
  'scheduleTextOrMediaVariations',
  'tikTokAudienceRequired',
  'tikTokMediaLimit',
  'tikTokTextCharLimit',
  'tikTokVideoLength',
  'tikTokVideoSize',
  'titleCharLimit',
  'twitterMediaLimit',
  'twitterTextCharLimit',
  'videoNotTranscoded'
];

export type PostEditorFalidatorObject = {
  categoryRequired: typeof categoryRequiredFn;
  checkDateAndTime: typeof checkDateAndTimeFn;
  checkDisconectedProfiles: typeof checkDisconectedProfilesFn;
  checkExpiryCount: typeof checkExpiryCountFn;
  checkExpiryDate: typeof checkExpiryDateFn;
  checkLinkPreviewSuppressed: typeof checkLinkPreviewSuppressedFn;
  checkLinksPresent: typeof checkLinksPresentFn;
  checkQueuePosition: typeof checkQueuePositionFn;
  checkRecurringInterval: typeof checkRecurringIntervalFn;
  expireCountRequired: typeof expireCountRequiredFn;
  expireDateRequired: typeof expireDateRequiredFn;
  facebookContentRequired: typeof facebookContentRequiredFn;
  facebookMediaLimit: typeof facebookMediaLimitFn;
  facebookTextCharLimit: typeof facebookTextCharLimitFn;
  facebookTwitterLineBreakLimit: typeof facebookTwitterLineBreakLimitFn;
  finishUpload: typeof finishUploadFn;
  googleMediaLimit: typeof googleMediaLimitFn;
  googleMinMedia: typeof googleMinMediaFn;
  googleTextCharLimit: typeof googleTextCharLimitFn;
  instagramFacebookFirstCommentCharLimit: typeof instagramFacebookFirstCommentCharLimitFn;
  instagramHashtagLimit: typeof instagramHashtagLimitFn;
  instagramMediaLimit: typeof instagramMediaLimitFn;
  instagramTextCharLimit: typeof instagramTextCharLimitFn;
  linkedinFirstCommentCharLimit: typeof linkedinFirstCommentCharLimitFn;
  linkedinMediaLimit: typeof linkedinMediaLimitFn;
  linkedinTextCharLimit: typeof linkedinTextCharLimitFn;
  mediaRequired: typeof mediaRequiredFn;
  noGifsAllowed: typeof noGifsAllowedFn;
  noImagesAllowed: typeof noImagesAllowedFn;
  noMixedMedia: typeof noMixedMediaFn;
  noVideosAllowed: typeof noVideosAllowedFn;
  pinterestBoardRequired: typeof pinterestBoardRequiredFn;
  pinterestDuplicatesCheck: typeof pinterestDuplicatesCheckFn;
  pinterestLineBreakLimit: typeof pinterestLineBreakLimitFn;
  pinterestMediaLimit: typeof pinterestMediaLimitFn;
  pinterestTextCharLimit: typeof pinterestTextCharLimitFn;
  preventAudioOnlyFiles: typeof preventAudioOnlyFilesFn;
  preventPostNowForDisconnected: typeof preventPostNowForDisconnectedFn;
  preventTwDuplicate: typeof preventTwDuplicateFn;
  profileRequired: typeof profileRequiredFn;
  scheduleTextOrMediaVariations: typeof scheduleTextOrMediaVariationsFn;
  tikTokAudienceRequired: typeof tikTokAudienceRequiredFn;
  tikTokMediaLimit: typeof tikTokMediaLimitFn;
  tikTokTextCharLimit: typeof tikTokTextCharLimitFn;
  tikTokVideoLength: typeof tikTokVideoLengthFn;
  tikTokVideoSize: typeof tikTokVideoSizeFn;
  titleCharLimit: typeof titleCharLimitFn;
  twitterMediaLimit: typeof twitterMediaLimitFn;
  twitterTextCharLimit: typeof twitterTextCharLimitFn;
  videoNotTranscoded: typeof videoNotTranscodedFn;
};
export const ValidatorFunctionObject: PostEditorFalidatorObject = {
  categoryRequired: categoryRequiredFn,
  checkDateAndTime: checkDateAndTimeFn,
  checkDisconectedProfiles: checkDisconectedProfilesFn,
  checkExpiryCount: checkExpiryCountFn,
  checkExpiryDate: checkExpiryDateFn,
  checkLinkPreviewSuppressed: checkLinkPreviewSuppressedFn,
  checkLinksPresent: checkLinksPresentFn,
  checkQueuePosition: checkQueuePositionFn,
  checkRecurringInterval: checkRecurringIntervalFn,
  expireCountRequired: expireCountRequiredFn,
  expireDateRequired: expireDateRequiredFn,
  facebookContentRequired: facebookContentRequiredFn,
  facebookMediaLimit: facebookMediaLimitFn,
  facebookTextCharLimit: facebookTextCharLimitFn,
  facebookTwitterLineBreakLimit: facebookTwitterLineBreakLimitFn,
  finishUpload: finishUploadFn,
  googleMediaLimit: googleMediaLimitFn,
  googleMinMedia: googleMinMediaFn,
  googleTextCharLimit: googleTextCharLimitFn,
  instagramFacebookFirstCommentCharLimit: instagramFacebookFirstCommentCharLimitFn,
  instagramHashtagLimit: instagramHashtagLimitFn,
  instagramMediaLimit: instagramMediaLimitFn,
  instagramTextCharLimit: instagramTextCharLimitFn,
  linkedinFirstCommentCharLimit: linkedinFirstCommentCharLimitFn,
  linkedinMediaLimit: linkedinMediaLimitFn,
  linkedinTextCharLimit: linkedinTextCharLimitFn,
  mediaRequired: mediaRequiredFn,
  noGifsAllowed: noGifsAllowedFn,
  noImagesAllowed: noImagesAllowedFn,
  noMixedMedia: noMixedMediaFn,
  noVideosAllowed: noVideosAllowedFn,
  pinterestBoardRequired: pinterestBoardRequiredFn,
  pinterestDuplicatesCheck: pinterestDuplicatesCheckFn,
  pinterestLineBreakLimit: pinterestLineBreakLimitFn,
  pinterestMediaLimit: pinterestMediaLimitFn,
  pinterestTextCharLimit: pinterestTextCharLimitFn,
  preventAudioOnlyFiles: preventAudioOnlyFilesFn,
  preventPostNowForDisconnected: preventPostNowForDisconnectedFn,
  preventTwDuplicate: preventTwDuplicateFn,
  profileRequired: profileRequiredFn,
  scheduleTextOrMediaVariations: scheduleTextOrMediaVariationsFn,
  tikTokAudienceRequired: tikTokAudienceRequiredFn,
  tikTokMediaLimit: tikTokMediaLimitFn,
  tikTokTextCharLimit: tikTokTextCharLimitFn,
  tikTokVideoLength: tikTokVideoLengthFn,
  tikTokVideoSize: tikTokVideoSizeFn,
  titleCharLimit: titleCharLimitFn,
  twitterMediaLimit: twitterMediaLimitFn,
  twitterTextCharLimit: twitterTextCharLimitFn,
  videoNotTranscoded: videoNotTranscodedFn
};
